import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Collapse from '@mui/material/Collapse';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// import CONSTANTS from '../utils/Constants';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    marginTop: theme.spacing(1)
}));

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
    marginLeft: theme.spacing(2)
}));

class ConditionalSentiment extends Component {
    render() {
        let {visible, values, selection, changeHandler} = this.props;
        
        if(visible) {
            return (
                <StyledFormControl component="fieldset">
                    <Typography variant="subtitle1">How do you feel?</Typography>
                    <Collapse in={values.length > 3} collapsedSize="146px">
                        <StyledRadioGroup
                            aria-label="How do you feel?"
                            name="sentiment"
                            value={selection}
                            onChange={changeHandler}
                        >
                            {values.map(value => {
                                let lcValue = value.toLowerCase()
                                let cpValue = lcValue.slice(0, 1).toUpperCase() + lcValue.slice(1);
                                return (
                                    <FormControlLabel 
                                        value={lcValue} 
                                        key={lcValue} 
                                        control={<Radio aria-label={cpValue} />} 
                                        label={cpValue} 
                                    />
                                );
                            })}
                        </StyledRadioGroup>
                    </Collapse>
                </StyledFormControl>
            );
        
        } else {
            return null;
        }
    }
}

ConditionalSentiment.propTypes = {
    visible: PropTypes.bool,
    selection: PropTypes.string,
    values: PropTypes.array.isRequired,
    changeHandler: PropTypes.func.isRequired
};

export default ConditionalSentiment;